var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVoirPlus = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 5,
  viewBox: "0 0 18 5",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#C6C6C6",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.667,
  cy: 2.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.833,
  cy: 2.5,
  r: 1.5
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVoirPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/voir-plus.140528918a657af3080ffedfc65786e1.svg";